<template>
    <div>
      <v-row>
        <v-col cols="2">
          <IntegratorParser :order_id="order_id" :preloaded_manifest="preloaded_manifest" @mapped_samples="setSamples" @set_manifest_id="ccrsManifestId = $event" @set_customer="setCustomer">
            <template v-slot:activator="{on}">
              <v-btn v-on="on">CCRS</v-btn>
            </template>
          </IntegratorParser>
          <v-text-field v-model="ccrsManifestId" label="CCRS manifest ID"></v-text-field>
          <v-select v-model="license" label="License" :items="licenses" item-text="license" item-value="license" clearable></v-select>
          <v-autocomplete v-model="customer" :items="customerNames" @change="setAllCustomers" item-text="name" return-object label="customer" clearable outlined dense solo :disabled="saving">
          </v-autocomplete>
        </v-col>
        <v-col v-if="customer" cols="3">
          <v-card outlined tile>
            <v-card-text>
              <v-chip v-for="imperative in imperatives" :key="imperative.id" class="error">{{imperative.imperative_type.desc}}</v-chip>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="customer" cols="7">
          <v-card outlined tile>
            <v-card-text>
              <v-simple-table outlined dense>
                <tbody>
                <tr v-for="note in notes.filter(item => item.note_type.desc === 'Sample')" :key="note.id">
                  <td>
                    <CustomerSampleNoteMenu :text="note.note_type.desc" :note="note.note" :samples="samples" @update_all="updateAllNotes($event)" @update_one="updateOneNote(...$event)"></CustomerSampleNoteMenu>
                  </td>
                  <td>{{note.note}}</td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-form ref="form" @submit.prevent>
        <v-simple-table outlined dense>
          <thead>
          <tr>
            <th rowspan="2" class="pl-0 pr-1"></th>
            <th rowspan="2" v-if="!manifest" class="pa-0"></th>
            <th rowspan="2">
              <v-autocomplete v-model="legalType" :items="legalTypes" @change="setAllLegalTypes" label="Legal Type" clearable outlined dense solo :disabled="saving"></v-autocomplete>
            </th>
            <th rowspan="2">
              <v-autocomplete v-model="sampleCertType" :items="sampleCertTypes" @change="setAllCertTypes" item-text="name" item-value="uuid" label="Sample Type" outlined dense solo :disabled="saving">
              </v-autocomplete>
            </th>
            <th rowspan="2">Qa</th>
            <th rowspan="2">lot</th>
<!--            <th rowspan="2">-->
<!--              <v-autocomplete v-model="customer" :items="customerNames" @change="setAllCustomers" item-text="name" return-object label="customer" clearable outlined dense solo :disabled="saving">-->
<!--              </v-autocomplete>-->
<!--            </th>-->
<!--            <th>Unit Weight</th>-->
<!--            <th>-->
<!--              Harvest Date-->
<!--            </th>-->
            <th style="width: 1%;">
              <v-checkbox v-model="allRND" @change="toggleRnd" label="Is RND" outlined dense hide-details></v-checkbox>
            </th>
<!--            <th>Package Weight</th>-->
            <th style="width:1%;white-space:nowrap">
              <ToggleFlags @toggle_flags="toggleAllSampleFlag($event)"></ToggleFlags>
            </th>
          </tr>
          <tr>
<!--            <th colspan="8">-->
<!--              <v-divider></v-divider>-->
<!--            </th>-->
            <th colspan="2">
              <v-btn-toggle multiple>
                <v-btn v-for="type in testTypes" :key="type.uuid" @click="toggleTests(type.uuid)" active-class="white" class="black--text" icon small tile :disabled="saving">
                  {{ type.name }}
                </v-btn>
              </v-btn-toggle>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" @click="setAllRequirements()" tile small><v-icon>mdi-clipboard-check-outline</v-icon></v-btn>
                </template>
                <span>Set Requirements from sample type</span>
              </v-tooltip>
            </th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(sample, index) in samples">
            <tr class="sample_row_1" :key="`sample_row_1_${index}`">
              <td class="pl-0 pr-1">{{index}}</td>
              <td v-if="!manifest" class="pa-0">
                <v-btn @click="samples.splice(index,1)" color="error" small outlined><v-icon>remove</v-icon></v-btn>
              </td>
              <td>
                <v-text-field v-if="sample.legal_type && !legalTypes.includes(sample.legal_type)" v-model="sample.legal_type" :rules="formRules" label="Legal Type"></v-text-field>
                <v-autocomplete v-else v-model="sample.legal_type" :rules="formRules" :items="legalTypes" label="Legal Type" outlined dense></v-autocomplete>
              </td>
              <td>
                <v-autocomplete
                    v-model="sample.sample_cert_type_uuid"
                    :items="sampleCertTypes"
                    @change="setRequirements(sample)"
                    :rules="formRules"
                    item-text="name"
                    item-value="uuid"
                    label="Sample Type"
                    outlined dense
                    :disabled="saving"
                    persistent-hint
                    :hint="sample.legal_type"
                >
                </v-autocomplete>
              </td>
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-text-field v-model="sample.qa" v-on="on" :rules="manifest ? formRules : []" :hint="sample.qa" label="QA" @focus="$event.target.select()" persistent-hint outlined dense :disabled="saving"></v-text-field>
                  </template>
                  <span>{{sample.qa}}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-text-field v-model="sample.lot" v-on="on" label="LOT" :rules="manifest ? formRules : []" @focus="$event.target.select()" persistent-hint :hint="sample.lot" outlined dense :disabled="saving"></v-text-field>
                  </template>
                  <span v-if="manifest">{{sample.lot && sample.lot.includes('.') ? sample.lot.split('.')[1] : sample.lot}}</span>
                  <span v-else>{{sample.lot}}</span>
                </v-tooltip>
              </td>
<!--              <td>-->
<!--                <v-autocomplete v-model="sample.customer" :items="customerNames" :rules="formRules" item-text="name" return-object label="Customer" clearable outlined dense :disabled="saving"></v-autocomplete>-->
<!--              </td>-->
<!--              <td class=\"pb-5\">-->
<!--                <v-btn-toggle v-model=\"sample.sample_tests\"  multiple>-->
<!--                  <v-btn v-for=\"type in testTypes\" active-class=\"error white&#45;&#45;text\" class=\"black&#45;&#45;text\" icon small tile :value=\"type.uuid\" :disabled=\"saving\">-->
<!--                    {{ type.name }}-->
<!--                  </v-btn>-->
<!--                </v-btn-toggle>-->
<!--              </td>-->
<!--              <td>-->
<!--                <v-tooltip>-->
<!--                  <template v-slot:activator=\"{on}\">-->
<!--                    <v-text-field v-model=\"sample.serving_weight\" @focus=\"$event.target.select()\" label=\"Unit Weight\" type=\"number\" outlined dense :disabled=\"saving\"></v-text-field>-->
<!--                  </template>-->
<!--                  <span>{{sample.serving_weight}}</span>-->
<!--                </v-tooltip>-->
<!--              </td>-->
<!--              <td>-->
<!--                <v-tooltip>-->
<!--                  <template v-slot:activator=\"{on}\">-->
<!--                    <v-text-field v-model=\"sample.harvest_date\" outlined dense label=\"Harvest Date\" :disabled=\"saving\"></v-text-field>-->
<!--                  </template>-->
<!--                  <span>{{sample.harvest_date}}</span>-->
<!--                </v-tooltip>-->
<!--              </td>-->
              <td style="width: 1%;">
                <v-tooltip>
                  <template v-slot:activator="{on}">
                    <v-checkbox v-model="sample.is_rnd" outlined dense :disabled="saving" hide-details></v-checkbox>
                  </template>
                  <span>{{sample.serving_weight}}</span>
                </v-tooltip>
              </td>
<!--              <td>-->
<!--                <v-text-field v-if=\"sample.meta_data\" v-model=\"sample.meta_data.package_weight\" label=\"package weight\" outlined dense></v-text-field>-->
<!--              </td>-->
              <td style="width:1%;white-space:nowrap">
                <StepSampleCreateNote :ref="`sample_notes_${index}`" :sample="sample" :sample_index="index" :key="index" @set_notes="setNotes" @set_flags="setFlags">
                  <template v-slot:activator="{on:dialog, note_count, notes, flags}">
                    <v-badge :content="flags.length.toString()" color="green darken-2" overlap bordered>
                      <v-badge :content="note_count.toString()" left overlap bordered>
                        <v-tooltip bottom class="pa-0 ma-0">
                          <template v-slot:activator="{on:tooltip}">
                            <v-btn v-on="{...tooltip,...dialog}" tile small outlined :disabled="saving">Notes</v-btn>
                          </template>
                          <v-simple-table outlined dense>
                            <tbody>
                            <tr v-if="flags.length === 0">
                              <td >Flags:</td>
                              <td >none</td>
                            </tr>
                            <template v-else>
                              <tr v-for="flag in flags" :key="flag.sample_flag_type_uuid"><td><v-chip :color="flag.type.color" x-small></v-chip></td><td>{{flag.type.name}}</td></tr>
                            </template>
                            <tr v-if="notes.length === 0">
                              <td >Notes:</td>
                              <td >none</td>
                            </tr>
                            <template v-else>
                              <tr v-for="(note, index) in notes" :key="index"><td colspan="2">{{note.note}}</td></tr>
                            </template>
                            </tbody>
                          </v-simple-table>
                          </v-tooltip>
                          </v-badge>
                          </v-badge>
                  </template>
                </StepSampleCreateNote>
              </td>
            </tr>
            <tr class="sample_row_2" :key="`sample_row_2_${index}`">
              <td colspan="2"></td>
              <td>
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-combobox  v-model="sample.name" v-on="on" label="Sample Name" :items="sample.name_items" :rules="[...formRules, v => v.length < 80 || 'This field must be 80 characters or less']" outlined dense :disabled="saving"></v-combobox>
                    <!--                  <v-text-field v-else v-model=\"sample.name\" v-on=\"on\" label=\"Sample Name\" :rules=\"formRules\" outlined dense :disabled=\"saving\">-->
                    <!--                  </v-text-field>-->
                    <!--                  <div v-else>else?</div>-->
                  </template>
                  <span>{{sample.name}}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip>
                  <template v-slot:activator="{on}">
                    <v-text-field v-model="sample.serving_weight" @focus="$event.target.select()" label="Unit Weight" type="number" outlined dense :disabled="saving"></v-text-field>
                  </template>
                  <span>{{sample.serving_weight}}</span>
                </v-tooltip>
              </td>
<!--              <td>-->
<!--                <v-text-field v-if=\"sample.meta_data\" v-model=\"sample.meta_data.package_weight\" label=\"package weight\" outlined dense ></v-text-field>-->
<!--              </td>-->
              <td>
                <v-tooltip v-if="sample.meta_data">
                  <template v-slot:activator="{on}">
                    <v-text-field v-model="sample.meta_data.collection_date" outlined dense label="Collection Date" :disabled="saving" ></v-text-field>
                  </template>
                  <span>{{sample.meta_data.collection_date}}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip v-if="sample.meta_data">
                  <template v-slot:activator="{on}">
                    <v-text-field v-model="sample.meta_data.strain_name" outlined dense label="Strain Name" :disabled="saving" ></v-text-field>
                  </template>
                  <span>{{sample.meta_data.strain_name}}</span>
                </v-tooltip>
              </td>
              <td colspan="2" class="pb-5">
                <v-btn-toggle v-model="sample.sample_tests"  multiple>
                  <v-btn v-for="type in testTypes" :key="type.uuid" active-class="error white--text" class="black--text" icon small tile :value="type.uuid" :disabled="saving">
                    {{ type.name }}
                  </v-btn>
                </v-btn-toggle>
              </td>
            </tr>
          </template>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="9">
              <v-card-actions>
              <v-spacer v-if="!manifest"></v-spacer>
                <v-btn v-if="!manifest" @click="addSample" color="success">Add Another Sample</v-btn>
              <v-spacer></v-spacer>
                <Confirm
                    v-if="hasNon502"
                    message="You are submitting non-502 samples with a license, are you sure?"
                    @confirmed="saveSamples"
                >
                  <template v-slot:activator="{on}">
                    <v-btn v-on="on" :loading="saving" :disabled="saving">submit</v-btn>
                  </template>
                </Confirm>
                <v-btn v-else @click="saveSamples" :loading="saving" :disabled="saving">submit</v-btn>
              </v-card-actions>
            </td>
          </tr>
          </tfoot>
        </v-simple-table>
      </v-form>
    </div>
</template>

<script>
import {nanoid} from 'nanoid'
export default {
    name: "StepSampleCreate",
    components: {
      StepSampleCreateNote: () => import("@/views/orders/components/Manifest/StepSampleCreateNote"),
      IntegratorParser: () => import("@/views/Tracking/components/IntegratorParser"),
      CustomerSampleNoteMenu: () => import("@/views/orders/components/Manifest/CustomerSampleNoteMenu"),
      ToggleFlags: () => import("./ToggleFlags")
    },
    props:{
      manifest:{
        required:false,
      },
      preloaded_manifest:{
        required:false,
      },
    },
    data: () => ({
      toggledTests: [],
      selectedFlagTypes: [],
      order_id: null,
      saving: false,
      samples: [],
      imperatives: [],
      licenses: [],
      notes: [],
      customer: null,
      legalType: null,
      sampleCertType: null,
      license: null,
      allRND: false,
      ccrsManifestId: null,
      formRules: [
          v => !!v || "This field is required",
      ],
      legalTypePairs: {
        "HarvestedMaterial:WetOtherMaterial": null,
        "HarvestedMaterial:Waste": null,
        "HarvestedMaterial:MarijuanaMix": "IntermediateProduct:CannabisMix",
        "IntermediateProduct:MarijuanaMix": "IntermediateProduct:CannabisMix",
        "IntermediateProduct:ConcentrateforInhalation": "EndProduct:ConcentrateForInhalation",
        "IntermediateProduct:Non-SolventbasedConcentrate": "EndProduct:Non-SolventBasedConcentrate",
        "IntermediateProduct:HydrocarbonConcentrate": "EndProduct:HydrocarbonConcentrate",
        "IntermediateProduct:CO2Concentrate": "EndProduct:CO2Concentrate",
        "IntermediateProduct:EthanolConcentrate": "EndProduct:EthanolConcentrate",
        "IntermediateProduct:Waste": null,
        "EndProduct:MarijuanaMixPackaged": "EndProduct:CannabisMixPackaged",
        "EndProduct:MarijuanaMixInfused": "EndProduct:CannabisMixInfused",
        "EndProduct:UsableMarijuana": "EndProduct:UsableCannabis",
        "EndProduct:Waste": null,
      },
      legalTypes: [
        "NON-502:NON-502",
        "PropagationMaterial:Clones",
        "PropagationMaterial:Plant",
        "PropagationMaterial:Seed",
        "HarvestedMaterial:FlowerLot",
        "HarvestedMaterial:FlowerUnlotted",
        "HarvestedMaterial:OtherMaterialLot",
        "HarvestedMaterial:OtherMaterialUnlotted",
        "HarvestedMaterial:WetFlower",
        "IntermediateProduct:CannabisMix",
        "IntermediateProduct:CBD",
        "IntermediateProduct:FoodGradeSolventConcentrate",
        "IntermediateProduct:InfusedCookingMedium",
        "EndProduct:CannabisMixInfused",
        "EndProduct:CannabisMixPackaged",
        "EndProduct:Capsule",
        "EndProduct:CO2Concentrate",
        "EndProduct:ConcentrateForInhalation",
        "EndProduct:EthanolConcentrate",
        "EndProduct:HydrocarbonConcentrate",
        "EndProduct:LiquidEdible",
        "EndProduct:Non-SolventBasedConcentrate",
        "EndProduct:SampleJar",
        "EndProduct:SolidEdible",
        "EndProduct:Suppository",
        "EndProduct:Tincture",
        "EndProduct:TopicalOintment",
        "EndProduct:Transdermal",
        "EndProduct:UsableCannabis"
      ]
    }),
    computed:{
      customerNames(){
        if(!this.customer && !this.manifest){
          return this.$store.$db().model('names').query().all();
        }
        return this.$store.$db().model('names').query().where('customer_id', this.customer.customer_id).all();
      },
      testTypes(){
        let types = this.$store.$db().model('sampleTestTypes').all().filter(test => !["MQ"].includes(test.name));
        let filtered = this.$store.state.filtered_test_types || [];
        if (filtered.length === 0) return types;
        return types.filter(type => !filtered.includes(type.uuid));
      },
      sampleCertTypes(){
        return this.$store.$db().model('sampleCertTypes').all();
      },
      sampleFlagTypes(){
        let flags = this.$store.$db().model('sampleFlagTypes').query().orderBy("display_index").all();
        let filtered = this.$store.state.manifest_filtered_flags || [];
        if (filtered.length > 0) {
          return flags.filter(flag => !filtered.includes(flag.uuid));
        }
        return flags;
      },
      hasNon502(){
        return this.samples.some(sample => sample.legal_type && sample.legal_type.includes('502') && this.license);
      }
    },
    watch:{
      manifest(){
        this.mapManifest();
      },
      customer(v){
        if(v){
          this.getCustomerImperatives().catch(e => this.$store.dispatch("showError", 'Failed to load imperatives.'));
          this.getCustomerNotes().catch(e => this.$store.dispatch("showError", 'Failed to load Notes.'));
          this.getLicenses().catch(e => this.$store.dispatch("showError", 'Failed to load Licenses.'));
        }
      },
    },
    mounted(){
      if(!this.preloaded_manifest) this.mapManifest();
    },
    methods: {
      async getLicenses(){
        let licenses = await this.$store.$db().model('licenses').api().fetch({
          where: {
            key: 'customer_id',
            value: this.customer.customer_id
          },
        }, '', null, false)
        this.licenses = licenses.response.data;
      },
      async mapIntegratorManifest(){
        this.samples = [];
        this.customer= null;
        this.legalType= null;
        this.sampleCertType= null;
        const orderId = nanoid()
        this.order_id = orderId;
        if(!this.manifest){
          this.addSample();
          return;
        }
        if(!this.customer){
          this.customer = await this.findCustomer();
          if(this.customer){
            this.getCustomerImperatives().catch(e => this.$store.dispatch("showError", 'Failed to load imperatives.'));
            this.getCustomerNotes().catch(e => this.$store.dispatch("showError", 'Failed to load Notes.'));
            this.getLicenses().catch(e => this.$store.dispatch("showError", 'Failed to load Licenses.'));
          }
        }
        let sample = {
          id: null,
          customer_id: this.customer,
          customer: this.customer,
          order_id: orderId,
          customer_name_id: null,
          manifest_id: this.manifest.global_id,
          unit_uuid: this.$store.$db().model('units').query().where('name', 'g').first().uuid,
          weight: 0,
          created_by: this.$store.getters.id,
          updated_by: null,
          meta_data: {
              package_weight: null,
              collection_date: null,
              strain_name: null,
          }
        }
        this.samples = this.manifest.inventory_transfer_items.map(item => {
          return {
            ...sample,
            id: 'PENDING-'+nanoid(5),
            sample_cert_type: null,
            sample_cert_type_uuid: null,
            name: item.strain_name,
            inventory_name: item.inventory_name,
            name_items: [
              item.strain_name,
              item.inventory_name,
            ],
            sample_type_uuid: null,
            legal_type: item.intermediate_type,
            qa: item.global_received_inventory_id,
            lot: item.global_inventory_id,
            is_rnd: false,
            harvest_date: null,
            serving_weight: null,
            manifest_item: null,
            sample_tests: [],
            notes: [],
            meta_data: {
              package_weight: null,
              collection_date: null,
              strain_name: null,
            }
          }
        })
      },
      async mapManifest(){
        this.samples = [];
        const orderId = nanoid()
        this.order_id = orderId;
        if(!this.manifest && !this.preloaded_manifest){
          this.addSample();
          return;
        }
        if(!this.customer){
          console.log("FINDIN CUSTOMER")
          this.customer = await this.findCustomer();
          if(this.customer){
            console.log("FOUND CUSTOMER!")
            this.getCustomerImperatives().catch(e => this.$store.dispatch("showError", 'Failed to load imperatives.'));
            this.getCustomerNotes().catch(e => this.$store.dispatch("showError", 'Failed to load Notes.'));
            this.getLicenses().catch(e => this.$store.dispatch("showError", 'Failed to load Licenses.'));
          }
        }
        let sample = {
          id: null,
          customer_id: this.customer.customer_id,
          order_id: orderId,
          customer_name_id: null,
          manifest_id: this.manifest.global_id,
          unit_uuid: this.$store.$db().model('units').query().where('name', 'g').first().uuid,
          weight: 0,
          created_by: this.$store.getters.id,
          updated_by: null,
          meta_data: {
            package_weight: null,
            collection_date: null,
            strain_name: null,

          }
        }
        if(this.manifest.from_license_number){
          this.license = this.manifest.from_license_number;
        }
        this.samples = this.manifest.inventory_transfer_items.map(item => {
          return {
            ...sample,
            id: 'PENDING-'+nanoid(5),
            sample_cert_type: null,
            sample_cert_type_uuid: null,
            name: item.strain_name,
            inventory_name: item.inventory_name,
            name_items: [
              item.strain_name,
              item.inventory_name,
            ],
            sample_type_uuid: null,
            legal_type: item.intermediate_type,
            qa: item.global_received_inventory_id,
            lot: item.global_inventory_id,
            is_rnd: false,
            harvest_date: null,
            serving_weight: null,
            manifest_item: null,
            sample_tests: [],
            notes: [],
            sample_flags: [],
          }
        })
      },
      async setCustomer({customer_name, customer_license}){
        let cust = await this.findCustomerByLicense(customer_license);
        cust = cust ? this.findCustomerByName(cust.customer_id) : this.findCustomerByName(null, customer_name);
        this.license = customer_license;
        this.customer = cust ? cust : null;
        if(this.customer){
          this.setAllCustomers()
        }
      },
      findCustomerByName(customer_id = null, name = null){
        if(name){
          let name = this.customerNames.find(({name}) => name.toLowerCase().includes(name.toLowerCase()))
          customer_id = name ? name.customer_id : null;
        }
        return customer_id ? this.customerNames.find(name => name.customer_id === customer_id && name.name_type_id === 1): null;
      },
      async findCustomerByLicense(license){
        let query = await this.$store.$db().model('licenses').api().fetch({
          where: {
            key: "license",
            value: license
          }
        },"", null, true);
        if(query.response.data && query.response.data.length > 0){
          return query.response.data[0];
        }
        return null;
      },
      setSamples(samples){
        console.log('SET SAMPLES', samples)
        let legalTypeKeys = Object.keys(this.legalTypePairs);
        samples.forEach(sample => {
          if(legalTypeKeys.includes(sample.legal_type)){
            sample.legal_type = this.legalTypePairs[sample.legal_type]
          }
          if(!this.legalTypes.includes(sample.legal_type)){
            const findLegalTypeLowerCase = this.legalTypes.find(type => type.toLowerCase() === sample.legal_type.toLowerCase());
            if(findLegalTypeLowerCase){
              sample.legal_type = findLegalTypeLowerCase;
            }
          }
        })
        this.$set(this, 'samples', samples);
        console.log('SET SAMPLES', this.samples)
        // this.samples = samples;
      },
      async addSample(){
        this.samples.push({
          id: 'PENDING-'+nanoid(5),
          customer_id: this.customer ? this.customer.customer_id : null,
          customer: this.customer,
          order_id: this.order_id,
          legal_type: this.legalType ? this.legalType : null,
          customer_name_id: null,
          manifest_id: null,
          is_rnd: false,
          qa: null,
          lot: null,
          unit_uuid: this.$store.$db().model('units').query().where('name', 'g').first().uuid,
          weight: 0,
          created_by: this.$store.getters.id,
          updated_by: null,
          name_items: [],
          notes: [],
          sample_flags: [],
          sample_tests: this.toggledTests,
          meta_data: {
            package_weight: null,
            collection_date: null,
            strain_name: null,
          }
        })
      },
      async findCustomer(){
        let license = this.manifest.global_id.split('.')[0].substring(3);
        let customer = await this.$store.$db().model('licenses').api().fetch({
          where:{
            key: "license",
            value: license
          }
        }, '',null, false)
        if(customer.response.data.length > 0){
          return customer.response.data[0];
        }
        return null;
      },
      async getCustomerImperatives(){
        let imperatives = await this.$store.$db().model('imperatives').api().fetch({
          where: {
            key: 'customer_id',
            value: this.customer.customer_id
          },
          with: 'imperativeType',
        }, '', null, false)
        this.imperatives = imperatives.response.data;
      },
      async getCustomerNotes(){
        let notes = await this.$store.$db().model('notes').api().fetch({
          where: {
            key: 'customer_id',
            value: this.customer.customer_id
          },
          with: 'noteType',
        }, '', null, false)
        this.notes = notes.response.data;
      },
      setAllCertTypes(){
        for(const i in this.samples){
          this.$set(this.samples[i], 'sample_cert_type_uuid', this.sampleCertType);
          this.setRequirements(this.samples[i]);
        }
      },
      setAllRequirements(){
        for(const i in this.samples){
          this.setRequirements(this.samples[i]);
        }
      },
      setAllLegalTypes(){
        for(const i in this.samples){
          this.samples[i].legal_type = this.legalType;
        }
      },
      setAllCustomers(){
        this.getCustomerImperatives().then(() => {
          for(const i in this.samples){
            this.$set(this.samples[i], 'customer_id', this.customer.customer_id);
            this.$set(this.samples[i], 'customer', this.customer);

            this.setRequirements(this.samples[i]);

          }
        })
      },
      toggleRnd(){
        if(this.allRND){
          this.samples.forEach(sample => sample.is_rnd = true)
        }else{
          this.samples.forEach(sample => sample.is_rnd = false)
        }
      },
      toggleTests(test_uuid){
        let remove = this.samples.some(sample => sample.sample_tests.includes(test_uuid));
        if(remove){
          this.samples.forEach(sample => {
            let index = sample.sample_tests.findIndex(test => test === test_uuid);
            if(index !== -1){
              sample.sample_tests.splice(index,  1);
            }
          })
        }else{
          this.samples.forEach(sample => sample.sample_tests.push(test_uuid));
        }
      },
      setNotes(note){
        this.$set(this.samples[note.sample_index], 'notes', [...note.notes])
      },
      setFlags(flags){
        console.log("setFlags")
        this.$set(this.samples[flags.sample_index], 'sample_flags', [...flags.flags]);
      },
      toggleAllSampleFlag({add, remove}){
        for(let i = 0; i < this.samples.length; i+=1){
          let noteRef = this.$refs[`sample_notes_${i}`][0];
          let sample = this.samples[i];
          for(let a of add){
            if(!sample.sample_flags.some(flag => flag.sample_flag_type_uuid === a.uuid)){
              noteRef.addFlag(a);
            }
          }
          for(let r of remove){
            if(sample.sample_flags.some(flag => flag.sample_flag_type_uuid === r.uuid)){
              noteRef.addFlag(r);
            }
          }
          noteRef.save(true);
        }
      },
      setRequirements(sample){
        let sampleTypeRequirements = sample.sample_cert_type_uuid ? this.$store.$db().model('sampleCertTypes').query().with('requirements').find(sample.sample_cert_type_uuid).requirements.map(item => item.sample_test_type_uuid) : [];
        let imperativeMap = this.imperatives.map(imp => imp.imperative_type.desc.toLowerCase());
        let imperativeTests = this.testTypes.filter(test => imperativeMap.find(imp => imp.includes(test.description.toLowerCase())) && !sampleTypeRequirements.includes(test.uuid)).map(test => test.uuid);
        // sample.sample_tests = [...sampleTypeRequirements, ...imperativeTests]
        this.$set(sample, 'sample_tests', [...sampleTypeRequirements, ...imperativeTests])
      },
      updateAllNotes(note){
        this.samples.forEach((sample, index) => {

          let notes = [note, ...sample.notes]
          this.$set(this.samples[index], 'notes', [...notes]);
        })
      },
      updateOneNote(index, note){
        const sample = this.samples[index];
        this.$set(this.samples, index, {...sample, notes: [...sample.notes, note]});
      },
      async saveSamples(){
        if(this.samples.some(sample => !sample.legal_type.includes("NON-502")) && !this.ccrsManifestId){
          this.$store.dispatch("showError", "CCRS manifest ID is required on 502 samples")
          return
        }
        if(!this.$refs.form.validate()) return;
        this.saving = true;
        const order_id = nanoid();
        let samples = await this.$store.$db().model('samples').api().save({
          collection: this.samples.map(sample => {
            return {
              ...sample,
              order_id: order_id,
              customer_name_id: sample.customer.id,
              customer_id: sample.customer.customer_id,
              manifest_id: sample.manifest_id ? sample.manifest_id : this.ccrsManifestId,
              customer: null,
              meta_data: {
                license: this.license,
                package_weight: sample.meta_data.package_weight,
                collection_date: sample.meta_data.collection_date,
                strain_name: sample.meta_data.strain_name,
              },
              relations: [
                {relation: 'sampleNotes', data: sample.notes},
                {relation: 'sampleFlags', data: sample.sample_flags},
                {relation: 'sampleTests', data: sample.sample_tests.map(test => {
                    return {
                      uuid: null,
                      sample_test_type_uuid: test,
                      active: true,
                      unit_uuid: this.$store.$db().model('units').query().where('name', 'g').first().uuid,
                      created_by: this.$store.getters.id,
                      updated_by: this.$store.getters.id,
                    }
                  })}
              ]
            }
          })
        })
        if(this.preloaded_manifest){
          await this.$firestore.collection('wcia_manifests').doc(this.preloaded_manifest.transfer_id).delete()
        }
        this.saving = false;
        this.mapManifest();
        this.$store.dispatch("showSuccess", "Done! Sent samples to ConAn 3")
        this.$emit('next', samples.entities.samples)
      }
    }
}
</script>

<style>

.sample_row_1 td {
  padding-top: 10px !important;

  border-bottom: 0px solid #e0e0e0 !important;
}

/* If row 1 is hovered highlight it */
table tr.sample_row_1:hover {
  background: #e3e3e3 !important;
}

/* If row 1 is hovered highlight 1 more down*/
table tr.sample_row_1:hover + tr.sample_row_2 {
  background: #e3e3e3 !important;
}

/* If the row below it is hovered hightlight this row*/
table tr.sample_row_1:has(+ tr.sample_row_2:hover) {
  background: #e3e3e3 !important;
}

/* if row 2 is hovered highlight it*/
table tr.sample_row_2:hover {
  background: #e3e3e3 !important;
}

</style>
